import { create } from "zustand";
import { persist } from "zustand/middleware";
import i18n from "../i18n";
import { auth } from "../firebase";

const useLanguageStore = create(
  persist(
    (set) => {
      auth.languageCode = i18n.language || 'fr';

      return {
        language: i18n.language || 'fr',

        setLanguage: (lng) => {
          set({ language: lng });
          auth.languageCode = lng;
        },
      };
    },
    {
      name: "language-storage",
    }
  )
);

export default useLanguageStore;